import { Nilable } from "@shared/utils";
import { IPredictDataDTO, PredictDataDTO } from "./PredictData.DTO";
import { AgeRangeDTO, IAgeRangeDTO } from "./AgeRange.DTO";
import { IQuestionDTO, QuestionDTO } from "./Question.DTO";

export interface IBlackBoxRespuestaDTO {
    quality_coefficient: number;
    country: string;
    total_answers: number;
    age_range_dictionary: IAgeRangeDTO[];
    classified_questions_dictionary: IQuestionDTO[];
    predict_data: IPredictDataDTO[];
}

export class BlackBoxRespuestaDTO {
    public coefficient = 0;
    public country = "";
    public totalAnswers = 0;
    public ageRanges: AgeRangeDTO[] = [];
    public classifiedQuestions: QuestionDTO[] = [];
    public predictData = new PredictDataDTO();

    constructor(json: Nilable<Partial<IBlackBoxRespuestaDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }


    }
    cargarDTO(json: Partial<IBlackBoxRespuestaDTO>) {
        if (json?.quality_coefficient != null) {
            this.coefficient = json.quality_coefficient;
        }
        if (json?.country != null) {
            this.country = json.country;
        }
        if (json?.total_answers != null) {
            this.totalAnswers = json.total_answers;
        }
        if (json?.age_range_dictionary != null) {
            json.age_range_dictionary.forEach(element => {
                this.ageRanges.push(new AgeRangeDTO(element))
            });
        }
        if (json?.classified_questions_dictionary != null) {
            json.classified_questions_dictionary.forEach(element => {
                this.classifiedQuestions.push(new QuestionDTO(element))
            });
        }
        if (json?.predict_data != null) {
            this.predictData = new PredictDataDTO(json.predict_data[0]);
        }
    }
}
